// @ts-nocheck
import errorPanel from './errorPanel';

export { errorPanel as errorPagePanel };
